<template>
  <a-modal
    v-model:visible="visible"
    title="文件处理"
    :width="500"
    :after-close="afterClose"
  >
    <div class="mb-10">
      <div class="flex justify-between">
        <div>
          <span
            >文件名称：<span class="underline opacity-80">{{
              videoBasename
            }}</span>
          </span>
        </div>
        <div class="text-sm flex-shrink-0">
          <span v-if="status != 'complete'" class=""
            >{{ status == 'downloading' ? '工具下载中...' : '视频处理中...'
            }}<a-spin
          /></span>
          <span v-if="status == 'complete'" class="text-green-500"
            >处理完成</span
          >
        </div>
      </div>
      <!-- <div class="mt-2">
        <span v-if="!ffmpegExists" class="text-sm opacity-70"
          >视频工具下载中...</span
        >
      </div> -->
    </div>

    <template #footer>
      <a-button key="back" @click="handleCancle">取消上传</a-button>
      <a-button
        type="primary"
        :loading="status != 'complete'"
        @click="handleok"
      >
        确定上传
      </a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { useWatchfaceAndroid } from '@/hooks';
import { ElectronApi } from '@/services/electron.api';
import { RemoteLibsService } from '@/services/remote-libs.service';
import { WatchfaceService } from '@/services/watchface';
import { Track, VideoTrack } from 'mediainfo.js';
import { computed, nextTick, PropType, ref } from 'vue';

const visible = ref<boolean>(false);
const videoFile = ref('');
const videoTramsformedFile = ref('');
const track = ref<Track[]>([]);
const status = ref<'processing' | 'downloading' | 'complete'>('complete');

const emits = defineEmits<{
  (
    event: 'ok',
    data: {
      videoSrc: string;
      videoName: string;
      videoFps: number;
      w: number;
      h: number;
    }
  ): void;
}>();

defineExpose({
  open: async (data: { videoFile: string; track: Track[] }) => {
    visible.value = true;
    videoFile.value = data.videoFile;
    track.value = data.track;
    await nextTick();
    await transformVideo(data.videoFile);
  }
});

const videoBasename = computed(() => {
  return ElectronApi.path?.basename(videoFile.value) ?? '';
});

const { androidWatcfaceOS } = useWatchfaceAndroid();

const handleok = async () => {
  visible.value = false;
  // 将mp4文件移动到目录中
  const _videoFile = videoTramsformedFile.value;
  if (!_videoFile) return;

  const watchfaceService = new WatchfaceService();
  const basename = await watchfaceService.resource.addFile(_videoFile, {
    // 如果是大核，上传的视频文本必须放在_spriteExt目录下
    subDirs: androidWatcfaceOS.value == 'android' ? ['_spriteExt'] : undefined,
    deleteOriginal: true
  });

  const videoTrack = track.value.find(
    (item) => item['@type'] === 'Video'
  ) as VideoTrack;
  const {
    Width: videoWidth = 0,
    Height: videoHeight = 0,
    FrameRate = 30
  } = videoTrack ?? {};

  emits('ok', {
    videoSrc: basename ?? '',
    videoName: ElectronApi.path?.basename(videoFile.value) ?? '',
    videoFps: FrameRate,
    w: videoWidth,
    h: videoHeight
  });

  videoTramsformedFile.value = '';
};
const handleCancle = () => {
  visible.value = false;
};
const afterClose = () => {
  visible.value = false;
  videoFile.value = '';
  if (videoTramsformedFile.value) {
    ElectronApi.fs?.promises.rm(videoTramsformedFile.value);
    videoTramsformedFile.value = '';
  }
  track.value = [];
  status.value = 'complete';
};

const transformVideo = async (videoFile: string) => {
  try {
    const { path } = ElectronApi;
    const exists = await new RemoteLibsService().exists('ffmpeg');
    if (!exists) status.value = 'downloading';

    const ffmpeg = await new RemoteLibsService().getLibFilename('ffmpeg');
    if (!ffmpeg || !path) return;
    status.value = 'processing';

    const tempPath = await ElectronApi.getPath('temp');
    const tmpFilename = path.join(tempPath, Math.random() + '_tmp.mp4');
    await ElectronApi.execFile(ffmpeg, [
      '-i',
      videoFile,
      '-vcodec',
      'libx264',
      '-bf',
      '0',
      '-an',
      tmpFilename
    ]);
    videoTramsformedFile.value = tmpFilename;
  } catch (error) {
    console.log(error);
    videoTramsformedFile.value = '';
  } finally {
    status.value = 'complete';
  }
};
</script>

<style scoped></style>
